<template>
<div class="sidebar map-sidebar opportunity-list-sidebar">
	<div class="collapse-sidebar">
		<div class="sidebar-header">
			<h3 class="sidebar-title">
				Your search
			</h3>
			<div class="collapse-button" @click="toggleMenu()">
				<img src="@/assets/images/left-arrow.png" alt="left-arrow">
			</div>
			<span class="collapse-title">Map View</span>
		</div>
		<hr>
		<div class="criteria-list">
			<span v-for="(item, index) in criteriaList" :key="index">
				<i @click="removeCriteria(item)">x</i>
				{{ item.value }}
			</span>
			<button class="button primary" @click="goToSearch()">Edit search</button>
		</div>
		<hr>
		<h4 class="results-text">Results...</h4>
		<ul class="opportunity-list">
			<li v-for="(item, index) in opportunities" :key="index"
				@mouseover="mouseoverOpportunity(item.id)"
				@mouseleave="mouseleaveOpportunity()"
				:class="item.id == activeInvest ? 'active' : ''"
				:id="'opportunity_' + item.id"
				@click="goToOpportunity(item.id)"
			>
				<p class="name">{{ item.name }}</p>
				<p class="sector">{{ item.sector.name }}</p>
			</li>
		</ul>
	</div>
</div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
	data: () => ({
		activeInvest: null,
		showSidebar: true
	}),
	computed: {
		...mapState({
			opportunities: ({ OpportunityStore }) => OpportunityStore.list,
			sectors: ({ SectorStore }) => SectorStore.list,
			regions: ({ RegionStore }) => RegionStore.list,
		}),
		criteriaList() {
			let commonList = []
			let query = this.$route.query
			let selectedSectors = []
			if(query.sectorId) {
				selectedSectors = query.sectorId
				if(typeof query.sectorId == 'string') {
					selectedSectors = [query.sectorId]
				}
			}
			let selectedRegions = []
			if(query.regionId) {
				selectedRegions = query.regionId
				if(typeof query.regionId == 'string') {
					selectedRegions = [query.regionId]
				}
			}

			if(query.name_like) {
				commonList.push({
					type: 'name_like',
					id: 0,
					value: query.name_like
				})
			}
			selectedSectors.map(id => {
				this.sectors.map(item => {
					if(item.id.toString() == id.toString()) {
						commonList.push({
							type: 'sectorId',
							id: item.id,
							value: item.name
						})
					}
				})
			})
			selectedRegions.map(id => {
				this.regions.map(item => {
					if(item.id.toString() == id.toString()) {
						commonList.push({
							type: 'regionId',
							id: item.id,
							value: item.name
						})
					}
				})
			})
		
			return commonList
		}
	},
	created() {
		this.getSectors()
	},
	mounted() {
		this.$root.$emit('removeAllPointsOfInterest')
		this.$root.$on('activateOpportunity', (id) => {
			this.activeInvest = id
			let activeElement = document.getElementById('opportunity_' + id)
			activeElement.scrollIntoView({ behavior: 'smooth' })
		})
		this.$root.$on('deactivateOpportunities', () => {
			this.activeInvest = null
		})
		this.getOpportunities().then(() => {
			this.$root.$emit('createMarkers', this.opportunities)
			this.$root.$emit('highlightRegions')
		})
	},
	methods: {
		...mapActions({
			getOpportunities: 'OpportunityStore/getList',
			getSectors: 'SectorStore/getList'
		}),
		mouseoverOpportunity(id) {
			this.$root.$emit('activateMarker', id)
			this.activeInvest = id
		},
		mouseleaveOpportunity() {
			this.$root.$emit('hideActiveMarkers')
			this.activeInvest = null
		},
		goToOpportunity(id) {
			this.$router.push({
				name: 'opportunity',
				params: {
					opportunityId: id
				},
				query: {
					...this.$route.query
				}
			})
		},
		goToSearch() {
			this.$router.push({
				name: 'map-search',
				query: {
					...this.$route.query
				}
			})
		},
		toggleMenu() {
			this.showSidebar = !this.showSidebar
			let menuElement = document.getElementsByClassName('opportunity-list-sidebar')[0]
			if(this.showSidebar) {
				menuElement.style.left = '56px'
				menuElement.classList.remove('hidden')
				this.$root.$emit('stopMarkerAnimation')
			} else {
				menuElement.style.left = '-192px'
				menuElement.classList.add('hidden')
				this.$root.$emit('runMarkerAnimation')
				this.$root.$emit('hideMapTypeMenu')
			}
		},
		removeCriteria(item) {
			let query = this.$route.query
			if(item.type == 'name_like') {
				query = {
					...query,
					name_like: undefined
				}
			} else {
				let list = query[item.type]
				list = typeof list == 'string' ? [list] : list
				list = list.filter(element => {
					return element != (item.id).toString() && element != '0'
				})
				query = {
					...query,
					[item.type]: list
				}
			}
			this.$router.replace({query})
			this.getOpportunities().then(() => {
				this.$root.$emit('createMarkers', this.opportunities)
				this.$root.$emit('highlightRegions')
			})
		}
	}
}
</script>

<style lang="scss">
.opportunity-list-sidebar {
	overflow-y: scroll;
	scrollbar-width: none;
	transition: left 0.5s linear;

	.sidebar-header {
		display: inline-block;
		width: 265px;

		.sidebar-title {
			float: left;
			user-select: none;
		}
		.collapse-button {
			float: right;
			width: 20px;
			height: 20px;
			transform: rotate(180deg);
			border-right: 2px solid #fff;
			padding: 2px 4px;
			margin-top: 5px;
			cursor: pointer;
			transition: transform 0.5s linear;

			img {
				width: 100%;
			}
		}
		.collapse-title {
			float: right;
			line-height: 35px;
			color: #3a9bc9;
			margin-right: 5px;
			margin-right: 12px;
			font-size: 13px;
			user-select: none;
		}
	}
	hr {
		margin: 5px 0 !important;
	}
	.criteria-list {
		display: inline-block;

		span {
			color: #999999;
			border: 1px solid #8a8c91;
			padding: 5px 10px;
			border-radius: 15px;
			margin: 5px 5px 0px 0px;
			user-select: none;
			float: left;
			text-transform: uppercase;
			font-size: 10px;

			i {
				font-style: normal;
				margin-right: 5px;
				font-size: 8px;
				position: relative;
				bottom: 0.6px;
				cursor: pointer;
			}
		}
		.button {
			float: left;
			padding: 4px 10px;
			width: auto;
			font-size: 10px;
			margin: 5px 5px 0px 0px;
		}
	}
	.results-text {
		user-select: none;
		color: #fff;
		text-align: left;
		margin: 15px 0 20px 0px;
		font-weight: 300;
		font-size: 15px;
	}
	.opportunity-list {
		background: #131821;
		padding: 0;
		list-style: none;
		margin: 0;

		li {
			padding: 10px 15px;
			margin: 1px 0px;
			position: relative;
			border-bottom: 1px solid #000;
			cursor: pointer;
			
			p {
				margin: 0;
				text-align: left;
				color: #fff;
				font-size: 13px;
			}
			.sector {
				font-style: italic;
				margin-top: 8px;
				font-weight: 200;
				font-size: 12px;
			}
			&:last-child {
				border-bottom: none;
			}
			&:hover {
				background: #49a589;
			}
		}
		li.active {
			background: #49a589;
		}
	}

	&::-webkit-scrollbar { 
		display: none; 
	}
}
.opportunity-list-sidebar.hidden {
	.collapse-button {
		transform: rotate(0deg);
	}
}
</style>
